<div class="cliente-titulo">
    <!-- Limite do Cliente -->
    <div class="cliente-titulo-limite" *ngIf="isShowLimiteCredito">
        <sgt-collapse-group title="Limite de Crédito" [isCollapsedInDefault]="false">
            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <label for="limiteCredito" class="col-form-label">Limite de Crédito</label>
                    <input type="text" class="form-control text-right" [value]="clienteLimite?.limiteCredito | currencyFormat: 1:2:2" name="limiteCredito"
                        id="limiteCredito" disabled="disabled" readonly="readonly">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="limiteCreditoDisponivel" class="col-form-label">Limite Disponível</label>
                    <input type="text" class="form-control text-right" [value]="clienteLimite?.limiteCreditoDisponivel | currencyFormat: 1:2:2" name="limiteCreditoDisponivel"
                        id="limiteCreditoDisponivel" disabled="disabled" readonly="readonly">
                </div>    
            </div>
        </sgt-collapse-group>
    </div>

    <!-- Resumo -->
    <div class="cliente-titulo-resumo">
        <sgt-collapse-group title="Resumo dos Títulos" [isCollapsedInDefault]="false">
            <div class="row">
                <div class="col-12">
                   <sgt-titulo-receber-resumo
                        #tituloReceberResumo>
                   </sgt-titulo-receber-resumo>
                </div>
            </div>
        </sgt-collapse-group>
    </div>

    <!-- Títulos -->
     <div class="cliente-titulo-view-container">
         <sgt-cliente-titulo-receber-view
            #tituloReceberView
            [idsPessoasFilter]="idsPessoasFilter">
         </sgt-cliente-titulo-receber-view>
     </div>

    <!-- <sgt-collapse-group title="Títulos">

    </sgt-collapse-group> -->
</div>